import React, { useEffect, useState } from 'react';

function PdfViewerModal() {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [pdfTitle, setPdfTitle] = useState('Relatório');
  const [scale, setScale] = useState(100);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Função para detectar se é Android
  const isAndroid = () => {
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
      navigator.userAgent.toLowerCase()
    );
  };

  // Função para imprimir diretamente
  const printDirectly = (url) => {
    const printWindow = window.open(url, '_blank');
    if (printWindow) {
      printWindow.onload = () => {
        printWindow.print();
        // Fecha a aba após 1 segundo da abertura da impressão
        setTimeout(() => {
          printWindow.close();
        }, 1000);
      };
    }
  };

  // Função para carregar dados do PDF
  const loadPdfData = () => {
    const pdfData = localStorage.getItem('pdfViewerData');
    if (pdfData) {
      try {
        const { url, title } = JSON.parse(pdfData);
        setPdfUrl(url);
        setPdfTitle(title || 'Relatório');
        const isMobileDevice = isAndroid();
        setIsMobile(isMobileDevice);

        // Se for Android, vai direto para impressão
        if (isMobileDevice) {
          setTimeout(() => {
            printDirectly(url);
            localStorage.removeItem('pdfViewerData');
          }, 100);
        }
      } catch (error) {
        console.error('Erro ao recuperar dados do PDF:', error);
      }
    }
  };

  // Recuperar dados do localStorage quando o componente montar e monitorar mudanças
  useEffect(() => {
    loadPdfData();

    // Listener para evento customizado disparado pelo Navbar
    const handlePdfUpdate = () => {
      loadPdfData();
    };

    window.addEventListener('pdfViewerUpdate', handlePdfUpdate);

    // Polling para detectar mudanças no localStorage (fallback)
    const pollInterval = setInterval(() => {
      loadPdfData();
    }, 500);

    return () => {
      window.removeEventListener('pdfViewerUpdate', handlePdfUpdate);
      clearInterval(pollInterval);
    };
  }, []);

  const handleDownload = () => {
    if (pdfUrl) {
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = `${pdfTitle || 'relatorio'}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handlePrint = () => {
    if (pdfUrl) {
      const printWindow = window.open(pdfUrl);
      if (printWindow) {
        printWindow.print();
      }
    }
  };

  const handleClose = () => {
    localStorage.removeItem('pdfViewerData');
    setPdfUrl(null);
    setPdfTitle('Relatório');
  };

  if (!pdfUrl) return null;

  // Em Android, o modal não é renderizado (já vai direto para impressão)
  if (isMobile) {
    return null;
  }

  // Comportamento normal para Desktop (iframe)
  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
    >
      <div className="modal-dialog modal-lg" style={{ maxWidth: '85vw', height: '85vh' }}>
        <div className="modal-content h-100">
          {/* Header */}
          <div className="modal-header bg-primary text-white py-2">
            <div className="d-flex align-items-center flex-grow-1">
              <i className="bi bi-file-earmark-pdf me-2"></i>
              <h6 className="m-0 flex-grow-1">
                {pdfTitle || 'Visualizador de Relatório'}
              </h6>
            </div>

            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={handleClose}
              title="Fechar"
            ></button>
          </div>

          {/* Body com PDF */}
          <div className="modal-body p-0 pdf-viewer-container" style={{ flex: 1, overflow: 'hidden' }}>
            <iframe
              src={pdfUrl}
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
              }}
              title="PDF Viewer"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PdfViewerModal;
